/* STARKFELD Trainingsplan (TRP-01), zu sections/sf-regen-plan.liquid.
 * Alles Sichtbare steht serverseitig im HTML. Dieses Skript schaltet nur:
 * Reiter (Szenarien), Tagesauswahl (Detail), Pop-up (natives dialog, Fokusfalle und Esc vom Browser)
 * mit Live-Vorschau des persoenlichen Plans und den Versand an STL-Ops-Marketing (Double-Opt-in).
 * Ohne vollstaendige Formularbindung bleibt der Versand gesperrt; es erscheint keine Versandbestaetigung.
 * buildPlan() und renderDoc() muessen zu snippets/sf-regen-plan-doc.liquid passen.
 * 29.09.2026 (SF-LIB-REGENPLAN-03): Quiz-Modus (form[data-sfrp-quiz], popup_style quiz): vier Schritte,
 * Fortschritt, Zurueck/Weiter, Mausklick auf eine Kachel springt weiter, Enter = weiter, Fokus je Schritt,
 * Zusammenfassung statt Live-Vorschau. Ohne Produktfrage sendet die Front product=unknown. */
(function () {
  'use strict';
  if (window.customElements && customElements.get('sf-regen-plan')) return;

  var DOWS = ['MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO'];
  var DAYNAMES = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
  var LOADTXT = ['frei', 'leicht', 'mittel', 'hoch'];
  var PAT = { 1: [2], 2: [1, 3], 3: [0, 2, 4], 4: [0, 1, 3, 4], 5: [0, 1, 2, 3, 4], 6: [0, 1, 2, 3, 4, 6] };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function buildPlan(n, game) {
    n = Math.max(1, Math.min(6, n | 0));
    var base = PAT[n].slice(), tr = [];
    base.forEach(function (d) {
      var dd = d;
      if (dd === game) {
        var offs = [1, -1, 2, -2, 3, -3];
        for (var i = 0; i < offs.length; i++) {
          var c = (dd + offs[i] + 7) % 7;
          if (c !== game && base.indexOf(c) < 0 && tr.indexOf(c) < 0) { dd = c; break; }
        }
      }
      tr.push(dd);
    });
    var pre = game >= 0 ? (game + 6) % 7 : -9;
    var rec = [];
    if (game >= 0) rec.push(game);
    for (var i = 0; i < 7 && rec.length < 4; i++) {
      if (tr.indexOf(i) >= 0 && i !== game && i !== pre) rec.push(i);
    }
    if (rec.length < 3) {
      var start = game >= 0 ? game + 1 : 0;
      for (var j = 0; j < 7 && rec.length < 3; j++) {
        var k = (start + j) % 7;
        if (tr.indexOf(k) < 0 && rec.indexOf(k) < 0 && k !== game) rec.push(k);
      }
    }
    var days = DOWS.map(function (dw, i) {
      var type = i === game ? 'game' : (tr.indexOf(i) >= 0 ? 'train' : 'free');
      var l = type === 'game' ? 3 : (type === 'train' ? (i === pre ? 1 : 2) : 0);
      return { i: i, dow: dw, type: type, l: l, rec: rec.indexOf(i) >= 0 };
    });
    return { n: n, game: game, days: days, recN: rec.length };
  }

  function icon(cfg, name, size) {
    var file = name === 'check' ? 'check-seal' : name;
    var url = (cfg.icons && cfg.icons[file]) || '';
    if (!url) return '';
    var m = 'url(' + url + ') center/contain no-repeat';
    return '<span class="sfrp-ico"><svg class="sf-ico sf-ico--' + esc(name) + '" viewBox="0 0 24 24" width="' + size + '" height="' + size + '" style="background-color:currentColor;-webkit-mask:' + m + ';mask:' + m + '" aria-hidden="true" focusable="false"></svg></span>';
  }

  function renderDoc(cfg, sport, plan, has) {
    var d = cfg.doc, p = cfg.product;
    var recLabel = has ? p.label : 'Recovery', recIcon = has ? p.icon : 'recovery';
    var h = '<div class="sfrp-doc">';
    h += '<div class="sfrp-doc__top">' + (cfg.logo ? '<span class="sfrp-doc__logo"><img src="' + esc(cfg.logo) + '" width="104" height="42" alt="STARKFELD" loading="lazy" decoding="async"></span>' : '<span class="sfrp-doc__brand">STARKFELD</span>') + '<span class="sfrp-doc__tag">' + esc(d.tag) + '</span></div>';
    h += '<p class="sfrp-doc__title">Dein Regenerationsplan für ' + esc(sport.label) + '</p>';
    h += '<div class="sfrp-doc__chips">';
    h += '<span class="sfrp-doc__chip">' + icon(cfg, sport.icon, 14) + esc(sport.label) + '</span>';
    h += '<span class="sfrp-doc__chip">' + plan.n + ' ' + (plan.n === 1 ? 'Trainingstag' : 'Trainingstage') + '</span>';
    h += '<span class="sfrp-doc__chip">' + (plan.game >= 0 ? esc(sport.game) + ' am ' + DAYNAMES[plan.game] : 'Ohne ' + esc(sport.gameday)) + '</span>';
    h += '<span class="sfrp-doc__chip">' + icon(cfg, recIcon, 14) + (has ? esc(p.label) + ' vorhanden' : 'Noch ohne ' + esc(p.label)) + '</span>';
    h += '</div><ol class="sfrp-doc__rows" role="list">';
    plan.days.forEach(function (x) {
      var t = x.type === 'game' ? sport.game : (x.type === 'train' ? sport.train : 'Frei');
      h += '<li class="sfrp-doc__row"><b>' + x.dow + '</b><span><strong>' + esc(t) + '</strong></span><span class="sfrp-meter" data-level="' + x.l + '"><span class="sfrp-meter__bars"><i></i><i></i><i></i></span>' + LOADTXT[x.l] + '</span>';
      if (x.rec) h += '<span class="sfrp-doc__rec">' + icon(cfg, recIcon, 16) + esc(recLabel) + ' ' + (x.type === 'game' ? '30 Min' : '20 Min') + '</span>';
      else h += '<span class="sfrp-doc__rec is-off">' + (x.l === 0 ? 'Ruhetag' : 'Keine Einheit') + '</span>';
      h += '</li>';
    });
    h += '</ol><div class="sfrp-doc__sum">';
    h += '<div><b>' + plan.recN + ' ' + (plan.recN === 1 ? 'Einheit' : 'Einheiten') + '</b><span>im Rahmen von 3 bis 4 pro Woche</span></div>';
    h += '<div><b>' + esc(d.sum2v) + '</b><span>' + esc(d.sum2l) + '</span></div>';
    h += '<div><b>' + esc(d.sum3v) + '</b><span>' + esc(d.sum3l) + '</span></div></div>';
    if (!has && d.trial) h += '<div class="sfrp-doc__note">' + icon(cfg, 'trial-60', 18) + '<span>' + esc(d.trial) + '</span></div>';
    if (d.note) h += '<div class="sfrp-doc__note">' + icon(cfg, 'info', 18) + '<span>' + esc(d.note) + '</span></div>';
    h += '<div class="sfrp-doc__foot"><span>starkfeld.com</span><span>Seite 1 von 2</span></div></div>';
    return h;
  }

  function validEmail(v) { v = (v || '').trim(); return v.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  class SfRegenPlan extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var cfgNode = this.querySelector('script[data-sfrp-config]');
      try { this.cfg = JSON.parse(cfgNode ? cfgNode.textContent : '{}'); } catch (e) { this.cfg = {}; }
      this.initTabs();
      this.initDays();
      this.initDialog();
    }

    initTabs() {
      var tabs = Array.prototype.slice.call(this.querySelectorAll('[data-sfrp-tab]'));
      if (!tabs.length) return;
      var self = this;
      function pick(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', String(on));
          x.tabIndex = on ? 0 : -1;
          var p = self.querySelector('#' + x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          var n;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i + tabs.length - 1) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== undefined) { e.preventDefault(); pick(tabs[n], true); }
        });
      });
    }

    initDays() {
      this.querySelectorAll('[data-sfrp-panel]').forEach(function (panel) {
        var btns = Array.prototype.slice.call(panel.querySelectorAll('[data-sfrp-day]'));
        btns.forEach(function (b) {
          b.addEventListener('click', function () {
            btns.forEach(function (x) {
              var on = x === b;
              x.setAttribute('aria-pressed', String(on));
              var d = panel.querySelector('#' + x.getAttribute('aria-controls'));
              if (d) d.hidden = !on;
            });
          });
        });
      });
    }

    initDialog() {
      var dlg = this.querySelector('dialog[data-sfrp-dialog]');
      if (!dlg) return;
      this.dlg = dlg;
      var self = this;
      this.panel = dlg.querySelector('[data-sfrp-dlg-panel]');
      this.form = dlg.querySelector('form[data-sfrp-form]');
      this.docwrap = dlg.querySelector('[data-sfrp-docwrap]');
      this.quiz = this.form.hasAttribute('data-sfrp-quiz');
      this.querySelectorAll('[data-sfrp-open]').forEach(function (b) {
        b.addEventListener('click', function () { self.open(b); });
      });
      dlg.querySelectorAll('[data-sfrp-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('sfrp-lock');
        if (self.opener && document.contains(self.opener)) self.opener.focus();
      });
      var next = dlg.querySelector('[data-sfrp-next]');
      var back = dlg.querySelector('[data-sfrp-back]');
      if (this.quiz) {
        this.initQuiz(next, back);
      } else {
        if (next) next.addEventListener('click', function () { self.panel.setAttribute('data-step', '2'); self.panel.scrollTop = 0; if (back) back.focus(); });
        if (back) back.addEventListener('click', function () { self.panel.setAttribute('data-step', '1'); self.panel.scrollTop = 0; if (next) next.focus(); });
      }
      this.form.addEventListener('change', function () { self.update(); });
      var more = dlg.querySelector('[data-sfrp-more]');
      if (more) more.addEventListener('click', function () { var box = dlg.querySelector('[data-sfrp-sports]'); if (box) box.classList.add('is-open'); more.setAttribute('aria-expanded', 'true'); var first = box && box.querySelector('.sfrp-chip--more input'); if (first) first.focus(); });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); if (self.quiz && self.step < self.steps.length) { self.advance(e, true); return; } self.submit(); });
    }

    /* Quiz: Schritte 1 bis 3 sind Fragen (Sportart, Trainingstage, Spieltag), Schritt 4 ist die E-Mail. */
    initQuiz(next, back) {
      var self = this, form = this.form;
      this.steps = Array.prototype.slice.call(form.querySelectorAll('[data-sfrp-step]'));
      this.next = next;
      this.back = back;
      this.step = parseInt(form.getAttribute('data-step') || '1', 10) || 1;
      if (next) next.addEventListener('click', function (e) { self.advance(e, true); });
      if (back) back.addEventListener('click', function () { self.go(self.step - 1, true); });
      // Accepting a default counts too; focus and script-generated activations do not.
      form.addEventListener('click', function (e) {
        var tile = e.target.closest('.sfrp-qz__tile');
        var current = self.steps[self.step - 1];
        if (tile && current && current.contains(tile)) self.requestStart(e);
      });
      form.addEventListener('keydown', function (e) {
        var current = self.steps[self.step - 1];
        // Scripted radio.click() can emit a trusted change. Use the activation itself.
        if (current && current.contains(e.target) && e.target.matches('input[type="radio"]') && [' ', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) >= 0) self.requestStart(e);
      });
      // Mausklick oder Tipp auf eine Kachel: kurz die Auswahl zeigen, dann weiter. Tastatur (detail 0) bleibt auf dem Schritt.
      form.addEventListener('click', function (e) {
        if (e.detail === 0 || self.step >= self.steps.length) return;
        var tile = e.target.closest('.sfrp-qz__tile');
        if (!tile || !form.contains(tile)) return;
        var now = Date.now();
        if (self.advAt && now - self.advAt < 400) return;
        self.advAt = now;
        var from = self.step;
        setTimeout(function () { if (self.step === from && self.dlg.open) self.go(from + 1, false); }, 170);
      });
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || self.step >= self.steps.length) return;
        var t = e.target;
        if (t && (t.tagName === 'BUTTON' || t.tagName === 'A' || t.tagName === 'TEXTAREA')) return;
        e.preventDefault();
        self.advance(e, true);
      });
      this.go(this.step, false);
    }

    advance(e, focus) {
      var current = this.steps[this.step - 1];
      if (!this.dlg.open || this.sent || this.step >= this.steps.length || !current || !current.querySelector('input[type="radio"]:checked')) return;
      this.requestStart(e);
      this.go(this.step + 1, focus);
    }

    requestStart(e) {
      // requestSubmit() may produce a trusted submit event without user input.
      if (!e.isTrusted || (e.type !== 'click' && e.type !== 'keydown') || !this.dlg.open || this.sent || this.startRequested) return;
      this.startRequested = true;
      this.sendStart();
      this.prepareChallenge();
    }

    async sendStart() {
      var b = this.binding();
      if (!b || !this.startRequested || !this.startNonce || this.startSending || this.startFinished) return;
      this.startSending = true;
      // Independent of signup: at most three attempts, always with the first nonce.
      try {
        for (var attempt = 0; attempt < 3; attempt++) {
          var ctl = new AbortController();
          var timeout = setTimeout(function () { ctl.abort(); }, 5000);
          try {
            var r = await fetch(b.endpoint + '/start', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ nonce: this.startNonce }), credentials: 'omit', mode: 'cors', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer', signal: ctl.signal });
            if (r.ok || (r.status < 500 && r.status !== 408 && r.status !== 429)) break;
          } catch (e) { /* Measurement failure must not block signup. */ }
          finally { clearTimeout(timeout); }
          if (attempt < 2) await new Promise(function (resolve) { setTimeout(resolve, attempt === 0 ? 250 : 1000); });
        }
      } finally {
        this.startSending = false;
        this.startFinished = true;
      }
    }

    go(n, focus) {
      if (!this.quiz) return;
      var total = this.steps.length;
      n = Math.max(1, Math.min(total, n | 0));
      this.step = n;
      this.form.setAttribute('data-step', String(n));
      this.steps.forEach(function (s, i) { s.hidden = i !== n - 1; });
      var label = this.dlg.querySelector('[data-sfrp-prog-label]');
      if (label) label.textContent = 'Schritt ' + n + ' von ' + total;
      var bar = this.dlg.querySelector('[data-sfrp-prog]');
      if (bar) bar.style.width = Math.round(n / total * 100) + '%';
      if (this.back) this.back.hidden = n === 1 || !!this.sent;
      if (this.next) this.next.hidden = n === total;
      if (n === total) this.update();
      this.panel.scrollTop = 0;
      var main = this.dlg.querySelector('.sfrp-qz__main');
      if (main) main.scrollTop = 0;
      var cur = this.steps[n - 1];
      var target = n === total ? cur.querySelector('[data-sfrp-email]') : (cur.querySelector('input:checked') || cur.querySelector('input'));
      if (target && (focus || n < total)) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
    }

    state() {
      var f = this.form;
      function val(name) { var el = f.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : null; }
      var key = val('sport');
      var sports = this.cfg.sports || [];
      var sport = sports.filter(function (s) { return s.key === key; })[0] || sports[0] || { key: 'sport', label: 'Sport', icon: 'recovery', train: 'Training', game: 'Spiel', gameday: 'Spieltag' };
      var hasField = !!f.querySelector('input[name="product"]');
      var product = hasField ? (val('product') === 'none' ? 'no' : 'yes') : 'unknown';
      return { sport: sport, n: parseInt(val('days') || '3', 10), game: parseInt(val('gameday') || '-1', 10), has: product !== 'no', product: product };
    }

    update() {
      var st = this.state(), plan = buildPlan(st.n, st.game), self = this;
      if (this.docwrap) {
        this.docwrap.classList.add('is-updating');
        this.docwrap.innerHTML = renderDoc(this.cfg, st.sport, plan, st.has);
        requestAnimationFrame(function () { self.docwrap.classList.remove('is-updating'); });
      }
      var summary = this.dlg.querySelector('[data-sfrp-summary]');
      if (summary) {
        summary.innerHTML = '<span>' + icon(this.cfg, st.sport.icon, 16) + esc(st.sport.label) + '</span>'
          + '<span>' + st.n + ' ' + (st.n === 1 ? 'Trainingstag' : 'Trainingstage') + '</span>'
          + '<span>' + (st.game >= 0 ? esc(st.sport.game) + ' am ' + DAYNAMES[st.game] : 'Ohne ' + esc(st.sport.gameday)) + '</span>';
      }
      var dl = this.form.querySelector('[data-sfrp-days-label]');
      if (dl) dl.textContent = st.n + (st.n === 1 ? ' Tag' : ' Tage');
      this.form.querySelectorAll('[data-sfrp-gameday-term]').forEach(function (el) { el.textContent = st.sport.gameday; });
      var none = this.form.querySelector('input[name="gameday"][value="-1"]');
      if (none && this.cfg.texts && this.cfg.texts.none) none.setAttribute('aria-label', this.cfg.texts.none + ' ' + st.sport.gameday);
      var gl = this.form.querySelector('[data-sfrp-gameday-label]');
      if (gl) gl.textContent = st.game >= 0 ? DAYNAMES[st.game] : 'keiner';
      var sum = this.dlg.querySelector('[data-sfrp-sum]');
      if (sum) sum.textContent = plan.recN + ' ' + (plan.recN === 1 ? 'Einheit' : 'Einheiten') + ' · ' + (st.game >= 0 ? st.sport.gameday + ' ' + DAYNAMES[st.game] : 'ohne ' + st.sport.gameday);
      this.plan = plan;
    }

    open(opener) {
      this.opener = opener;
      if (typeof this.dlg.showModal === 'function') this.dlg.showModal(); else this.dlg.setAttribute('open', '');
      document.documentElement.classList.add('sfrp-lock');
      if (this.quiz) {
        this.update();
        this.go(this.sent ? this.steps.length : 1, true);
      } else {
        this.panel.setAttribute('data-step', '1');
        this.panel.scrollTop = 0;
        if (!this.plan) this.update();
      }
      this.prepareChallenge();
    }

    binding() {
      var b = this.cfg.binding || {};
      if (!b.formId || !/^[A-Za-z0-9_-]{1,64}$/.test(b.formId) || !/^https:\/\/[a-z0-9.-]+$/i.test(b.origin || '') || typeof b.consentVersion !== 'string' || !b.consentVersion.trim() || b.consentVersion.length > 64) return null;
      return { endpoint: b.origin + '/m/forms/starkfeld/' + b.formId, consent: b.consentVersion || '', source: b.source || '' };
    }

    prepareChallenge() {
      var b = this.binding(), self = this;
      if (!b || this.challenge || this.preparing) return;
      var started = performance.now();
      this.preparing = fetch(b.endpoint + '/challenge?instrumentation=funnel-start-v1', { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'omit', mode: 'cors', cache: 'no-store', referrerPolicy: 'no-referrer' })
        .then(function (r) { if (r.status !== 200) throw new Error('challenge'); return r.json(); })
        .then(function (j) {
          if (!j || typeof j.nonce !== 'string') throw new Error('challenge');
          self.challenge = { nonce: j.nonce, readyAt: started + (Number(j.minSubmitSeconds) || 0) * 1000 + 250 };
          if (!self.startNonce) self.startNonce = j.nonce;
          self.sendStart();
        })
        .catch(function () { self.challenge = null; })
        .finally(function () { self.preparing = null; });
    }

    message(text) {
      var m = this.dlg.querySelector('[data-sfrp-msg]');
      if (!m) return;
      m.textContent = text || '';
      m.hidden = !text;
    }

    done(email, preview) {
      var row = this.dlg.querySelector('[data-sfrp-row]'), consent = this.dlg.querySelector('[data-sfrp-consent]'), ok = this.dlg.querySelector('[data-sfrp-done]');
      if (row) row.hidden = true;
      if (consent) consent.hidden = true;
      this.sent = true;
      if (this.quiz) { if (this.back) this.back.hidden = true; if (this.next) this.next.hidden = true; }
      this.message('');
      if (ok) {
        var t = ok.querySelector('[data-sfrp-done-mail]');
        if (t) t.textContent = email;
        var pv = ok.querySelector('[data-sfrp-done-preview]');
        if (pv) pv.hidden = !preview;
        ok.hidden = false;
      }
    }

    async submit() {
      if (this.busy) return;
      var input = this.dlg.querySelector('[data-sfrp-email]');
      var email = (input && input.value || '').trim();
      var texts = this.cfg.texts || {};
      if (!validEmail(email)) { this.message(texts.invalid || 'Bitte gib eine gültige E-Mail-Adresse ein.'); if (input) input.focus(); return; }
      var b = this.binding();
      if (!b) { this.message(texts.unavailable || 'Der Versand ist gerade nicht verfügbar. Bitte versuche es später erneut.'); return; }
      var btn = this.dlg.querySelector('[data-sfrp-submit]');
      this.busy = true; if (btn) btn.disabled = true; this.message('');
      try {
        if (!this.challenge) { this.prepareChallenge(); if (this.preparing) await this.preparing; }
        if (!this.challenge) throw new Error('challenge');
        var wait = this.challenge.readyAt - performance.now();
        if (wait > 0) await new Promise(function (r) { setTimeout(r, Math.min(wait, 300000)); });
        var st = this.state();
        var hp = this.form.querySelector('[data-sfrp-hp]');
        var payload = { nonce: this.challenge.nonce, email: email, consentTextVersion: b.consent, locale: 'de', website: hp ? hp.value : '',
          sport: st.sport.key, training_days: String(st.n), gameday: st.game >= 0 ? DOWS[st.game].toLowerCase() : 'none', product: st.product, source: (b.source ? b.source + '-' : '') + st.sport.key };
        var ctl = new AbortController(); var to = setTimeout(function () { ctl.abort(); }, 15000);
        var r = await fetch(b.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload), credentials: 'omit', mode: 'cors', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer', signal: ctl.signal });
        clearTimeout(to);
        if (r.status !== 202) throw new Error('status');
        this.done(email, false);
        document.dispatchEvent(new CustomEvent('sf:guide-request-accepted'));
      } catch (e) {
        this.challenge = null;
        this.message(texts.error || 'Das hat nicht geklappt. Bitte versuche es gleich noch einmal.');
      } finally {
        this.busy = false; if (btn) btn.disabled = false;
      }
    }
  }

  if (window.customElements) customElements.define('sf-regen-plan', SfRegenPlan);
})();
